import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../.services/connection.service';
import { ChatService } from '../.services/chat.service';

declare var $: any;

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {

  connection: ConnectionService;
  users: Array<any>;
  isHost: boolean;
  selectedUserId: string;
  selectedUser: any;
  cService: ChatService;
  
  constructor(private connectionService: ConnectionService, private chatService: ChatService) { 
    this.connection = this.connectionService;
    this.cService = this.chatService;
    //this.users = this.connection.users;

    this.connection.userCast.subscribe((user)=> {
      this.users = this.connection.users;
    });
  }

  selectUser = (user) => {
    this.selectedUser = user;
    this.selectedUserId = user.id;
  }

  openChat = (user) => {
    $('#offCanvasUserList').foundation('close');
    $('#chatOffCanvas').foundation('open');
    this.cService.addTab(user.username);
    this.cService.selectTab(user.username);
    this.cService.highlightTab(user.username);

   

    //this.cService.addTab(user.username);
    
  }

  kick = () => { 
    /*
    let find = this.users.find(x  => {
      return x.id == this.selectedUserId;
    });

    if(find) {
      this.connection.connection.streamEvents[find.streamId].stream.mute();
    }
    */

    this.connection.kickUser(this.selectedUserId);
  }

  ngOnInit() {
      
    this.connection.cast.subscribe((value) => {
      this.isHost = value;
    });

    this.connection.userCast.subscribe((listOfUsers) => {
      this.users = listOfUsers;
    });
  }

}


